module.exports = __webpack_public_path__ + "img/500 Server error.ae686115.jpg";